import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../styles/Common/Breadcrump.css";

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div className="breadcrumb-container mx-3">
      {/* Back Button */}
      <div className="breadcrumb-back" onClick={() => navigate(-1)}>
        <span className="back-text">{'<'} Back</span>
      </div>

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          {pathnames.map((value, index) => {
            const url = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;

            return (
              <React.Fragment key={url}>
                <span className="breadcrumb-separator"> &gt; </span>
                <li className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                  {isLast ? (
                    <span>
                      {value.replace(/-/g, " ").charAt(0).toUpperCase() +
                        value.replace(/-/g, " ").slice(1)}
                    </span>
                  ) : (
                    <Link to={url}>
                      {value.replace(/-/g, " ").charAt(0).toUpperCase() +
                        value.replace(/-/g, " ").slice(1)}
                    </Link>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
